import type { ToastStorage } from './interface';

export const STORE_NAME = 'ToastStore';

export const initialState: ToastStorage = [];
